import React, { useState, useEffect, useContext} from "react"
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/fr'
import {
  Box,
  Container,
  Button,
  Hidden,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import BusinessIcon from '@material-ui/icons/Business';
import AlarmIcon from '@material-ui/icons/Alarm';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import {
  Box as BoxIcon,
} from 'react-feather';

import PageContentWrapper from "../PageContentWrapper"
import ViewResultsModal from "../ui/ViewResultsModal"

import ScansContext from "../../contexts/ScansContext"

import { getCurrentUser } from "../../utils/auth"
import { theLab_url } from "../../utils/APIS"

moment.locale("fr");


const ScanWrapper = ({ scan, type, modalViewResults, setModalViewResults }) => {
  return (
    <Box sx={{
      width:["100%", "calc(50% - 25px)", "calc(50% - 40px)"],
      background:"white",
      border:type==="invited" ? "1px solid black" : "1px solid #E7E7E7",
      padding:["15px", "20px", "30px"],
      maxWidth:"100%",
      display:"flex",
      flexDirection:"column",
      gap:["10px", "15px", "15px"],
    }}>
      <Box sx={{
        display:"flex",
        justifyContent:"space-between",
        gap:["0px", "10px", "10px"],
        alignItems:"center",
        flexDirection:["column", "row", "row"],
      }}>
        <Box sx={{
          display:"flex",
          overflow:"hidden",
          gap:"3px",
          alignItems:"center",
          textAlign:"left",
          width:["100%", "unset", "unset"],
        }}>
          <BusinessIcon sx={{width:"18px", height:"18px"}}/>
          <Box sx={{
            fontWeight:400,
            color:"text.primary",
            fontSize:["14px", "16px", "18px"],
            overflow:"hidden",
            textOverflow:"ellipsis",
            whiteSpace:"nowrap",
            textTransform:"capitalize",
          }}>
            {scan?.ownerName}
          </Box>
        </Box>
        {type === "invited" &&
          <Box sx={{
            fontWeight:400,
            color:"text.primary",
            fontSize:["12px", "13px", "14px"],
            overflow:"hidden",
            textOverflow:"ellipsis",
            whiteSpace:"nowrap",
            textAlign:"right",
            width:["100%", "unset", "unset"],
            textTransform:"capitalize",
          }}>
            {moment(scan?.invitCreatedAt).calendar()}
          </Box>
        }
      </Box>
      <Box sx={{
        fontWeight:500,
        color:"text.black",
        fontSize:["20px", "22px", "32px"],
        overflow:"hidden",
        textOverflow:"ellipsis",
        whiteSpace:"nowrap",
        textTransform:"capitalize",
      }}>
        {scan?.module?.name}
      </Box>
      <Box sx={{
        fontWeight:400,
        color:"text.primary",
        fontSize:["15px", "15px", "16px"],
        height:["55px", "55px", "58px"],
        overflow:"hidden",
        textOverflow:"ellipsis",
        lineClamp:3,
        display: "-webkit-box",
        WebkitLineClamp : 3,
        WebkitBoxOrient : "vertical",
      }}>
        {scan?.module?.description}
      </Box>
      <Box sx={{
        display:"flex",
        py:["3px", "5px", "8px"],
        gap:"10px",
        flexWrap:"wrap",
        alignItems:["flex-start", "center", "center"],
        flexDirection:["column", "row", "row"]
      }}>
        <Button
          sx={{
            order : [2, 1, 1],
          }}
          color="primary"
          size="large"
          type="submit"
          variant="contained"
          endIcon={type === "invited" ? <ChevronRightIcon/> : null}
          disabled={type === "completed" ? false : scan.isOpen === true ? false : true}
          onClick={() => {
            if (type === "invited") {
              window.location.href = theLab_url+"/thescan/"+scan?.usersGroupesID;
            } else if (type === "completed") {
              let vals = {
                actScan : scan,
                user : scan?.userFormations
              }
              setModalViewResults(vals)
            }
          }}
        >
          {(type === "invited" && scan?.scanStatus === "notStarted") && "Commencer"}
          {(type === "invited" && scan?.scanStatus === "inProgress") && "Continuer"}
          {type === "completed" && "Voir les résultats"}
        </Button>
        <Box sx={{
          order : [1, 2, 2],
          display:"flex",
          gap:"3px",
          alignItems:"center",
          color:"text.primary",
          maxWidth:"100%",
        }}>
          {(type === "invited" && scan?.scanStatus === "notStarted") && <AlarmIcon sx={{width:"18px", height:"18px"}}/>}
          {type === "completed" && <CheckCircleIcon sx={{width:"18px", height:"18px"}}/>}
          <Box sx={{
            fontWeight:400,
            color:"text.primary",
            fontSize:["14px", "16px", "16px"],
            overflow:"hidden",
            textOverflow:"ellipsis",
            whiteSpace:"nowrap",
            useSelect:"none",
            textTransform:"capitalize",
            maxWidth:"100%",
          }}>
            {(type === "invited" && scan?.isOpen !== true) && `Fermé`}
            {(type === "invited" && scan?.scanStatus === "notStarted" && scan?.isOpen === true) && `${scan?.module?.timing} minutes`}
            {(type === "invited" && scan?.scanStatus === "inProgress" && scan?.isOpen === true) && `${scan?.userFormations?.progress}% complété`}
            {type === "completed" && `Terminé ${moment(scan?.userFormations?.resultUpdatedAt).calendar()}`}
          </Box>
        </Box>

      </Box>
    </Box>
  )
}


const CandidatScans = ({ }) => {
  const navigate = useNavigate();
  const { isLoaded, scans } = useContext(ScansContext)

  const getFirstName = () => {
    let completeName = getCurrentUser()?.name
    return completeName?.split(" ")[0]
  }

  const [invitedScans, setInvitedScans] = useState([])
  const [completedScans, setCompletedScans] = useState([])
  const [scansLoaded, setScansLoaded] = useState(false)

  const [modalViewResults, setModalViewResults] = useState(false)

  useEffect(() => {
    if (isLoaded === true) {
      let invited = []
      let completed = []
      //on doit filtrer si complété ou pas
      scans.forEach((scan) => {
        if (scan?.scanStatus === "completed") {
          completed.push(scan)
        } else {
          invited.push(scan)
        }
      })
      setInvitedScans(invited)
      setCompletedScans(completed)
      setScansLoaded(true)
    }
  }, [isLoaded, scans])


  return (
    <>
      <PageContentWrapper
        title={"Bonjour, "+getFirstName()}
      >
        <Box sx={{display:"flex", flexDirection:"column", gap:["15px", "20px", "30px"], width:"100%"}}>
          {(scansLoaded === true && invitedScans?.length > 0) &&
            <Box>
              <Box sx={{
                fontSize:["22px", "28px", "32px"],
                fontWeight:500,
                color:"text.black",
              }}>
                Vous avez été invité
              </Box>
              <Box sx={{
                display:"flex",
                py:["10px", "15px", "20px"],
                gap:["15px", "25px", "40px"],
                flexWrap:"wrap",
               }}>
                {invitedScans.map((scan, index) => {
                  return (
                    <ScanWrapper
                      key={index}
                      scan={scan}
                      type={"invited"}
                      modalViewResults={modalViewResults}
                      setModalViewResults={setModalViewResults}
                    />
                  )
                })}
              </Box>
            </Box>
          }
          {(scansLoaded === true && completedScans?.length > 0) &&
            <Box>
              <Box sx={{
                fontSize:["22px", "28px", "32px"],
                fontWeight:500,
                color:"text.black",
              }}>
                Completés
              </Box>
              <Box sx={{
                display:"flex",
                py:["10px", "15px", "20px"],
                gap:["15px", "25px", "40px"],
                flexWrap:"wrap",
               }}>
               {completedScans.map((scan, index) => {
                 return (
                   <ScanWrapper
                     key={index}
                     scan={scan}
                     type={"completed"}
                     modalViewResults={modalViewResults}
                     setModalViewResults={setModalViewResults}
                   />
                 )
               })}
              </Box>
            </Box>
          }
        </Box>
        {(scansLoaded === true && invitedScans?.length === 0 && completedScans?.length === 0) &&
          <Box sx={{display:"flex",  flexDirection:"column", flex:1}}>
            <Box sx={{
              background:"white",
              border:"1px solid #E7E7E7",
              py : ["70px", "50px", "40px"],
              display:"flex",
              flexDirection:"column",
              alignItems:"center",
              gap:"20px"
            }}>
              <Box sx={{
                fontSize:["24px", "32px", "32px"],
                fontWeight : 500,
                textAlign:"center",
              }}>Aucun Scan disponible</Box>
            </Box>
          </Box>
        }
      </PageContentWrapper>

      <ViewResultsModal
        isOpen={modalViewResults === false ? false : true}
        actScan={modalViewResults?.actScan}
        user={modalViewResults?.user}
        onClose={() => setModalViewResults(false) }
        type="candidat"
      />
    </>
  )
};

export default CandidatScans;
